import { useTranslation } from 'react-i18next'
import { ShareBreakdownTable } from './ShareBreakdownTable'
import type { BreakdownTableProps } from './TargetingTotalsTable'
import { useMeasureStats } from '../hooks/useMeasureStats'
import { useStatLabel } from '../hooks/useStatLabel'

/** Measures the location endpoint reports. Continents land under `country`. */
const LOCATION_MEASURES = ['country', 'city']

const MEASURE_LABEL_KEYS: Record<string, string> = {
  country: 'stats.country',
  city: 'stats.city',
}

/** Delivery per country the ad request came from. */
export function LocationStatsTable({ query, range, maxHeight }: BreakdownTableProps) {
  const { t } = useTranslation()
  const statLabel = useStatLabel()
  const { groups, isLoading, error } = useMeasureStats('location', LOCATION_MEASURES, query, range)

  return (
    <ShareBreakdownTable
      groups={groups}
      groupLabel={(key) => t(MEASURE_LABEL_KEYS[key] ?? key)}
      valueLabel={statLabel('stats.impressions')}
      loading={isLoading}
      error={error}
      emptyMessage={t('stats.noLocationStats')}
      maxHeight={maxHeight}
    />
  )
}
